import PropTypes from 'prop-types'
import React from 'react';
import styles from './SummaryBox.module.scss'
import Button from "../../../../partials/Button";

function SummaryBox({sma, inclination, eccentricity, showReset = false, onReset = () => {}}) {
    return <div className={styles.SummaryBox}>
            <div className={styles.CurrentValues}>
                <div className={styles.Caption}>SMA:</div>
                <div className={styles.Value}>{`${sma} Km`}</div>
            </div>
            <div className={styles.CurrentValues}>
                <div className={styles.Caption}>Eccentricity:</div>
                <div className={styles.Value}>{eccentricity}</div>
            </div>
            <div className={styles.CurrentValues}>
                <div className={styles.Caption}>Inclination:</div>
                <div className={styles.Value}>{inclination}</div>
            </div>
        {showReset && onReset && <Button style={{zIndex:1}} text={"RESET"} onClick={ () => onReset() }/>}
    </div>
}
export default SummaryBox;

SummaryBox.propTypes = {
  sma: PropTypes.any,
  eccentricity: PropTypes.any,
  inclination: PropTypes.any,
  onReset: PropTypes.any
}

SummaryBox.defaultProps = {
  onReset: () => {}
}
